module.exports = __webpack_public_path__ + "img/hontai_L2538.eb0596ec.png";